
















































import {Vue, Component, Watch} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';

const channels = ['NAVER', 'FACEBOOK', 'DANAWA', 'ENURI', 'COOCHA', 'WONDER'];

@Component
export default class ComparingPriceSite extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  // 가격비교 사이트 선택정보
  //    NONE: 설정안함
  //    ANY: 설정
  //    ALL: 전체설정
  // 가격비교 사이트
  //    NAVER: 네이버쇼핑
  //    DAUM: 다음쇼핑하우(숨김)
  //    FACEBOOK: 페이스북 카탈로그(추가)
  //    ENURI: 에누리
  //    DANAWA: 다나와
  //    COOCHA: 쿠차
  //    PAYCO: 페이코쇼핑(숨김)
  //    WONDER: 위메프원더쇼핑(추가)
  private allComparingPrice = false;
  private comparingPriceSite: string[] = [];
  private comparingPrice = 'Y';
  private originComparingPriceSiteInfo = null;

  @Watch('comparingPriceSite')
  onComparingPriceSiteChange() {
    const selectedChannel = this.comparingPriceSite.filter(value => channels.includes(value));
    this.allComparingPrice = selectedChannel.length === channels.length;
  }

  @Watch('comparingPrice')
  onComparingPriceChange() {
    this.$nextTick(() => {
      this.setPopupSize();
    });
  }

  private get isShow() {
    return this.comparingPrice === 'Y';
  }

  private get check(): string {
    return this.comparingPrice === 'N' ? 'NONE' : this.comparingPriceSite.length === 6 ? 'ALL' : 'ANY';
  }

  private setPopupSize() {
    if (this.isShow) {
      document.body.classList.remove('popup_medium');
      document.body.classList.add('popup_large');
    } else {
      document.body.classList.remove('popup_large');
      document.body.classList.add('popup_medium');
    }
    this.popupResize();
  }

  private get productNo() {
    return this.$route.params.mallProductNos;
  }

  private allCheckEvent() {
    const defaultChannel = this.originComparingPriceSiteInfo.filter(value => !channels.includes(value));

    if (this.allComparingPrice) {
      this.comparingPriceSite = channels.slice();
    } else {
      this.comparingPriceSite = [];
    }
    this.comparingPriceSite = this.comparingPriceSite.concat(defaultChannel)
  }

  private save() {
    const params = {
      mallProductNos: this.productNo
    };
    const data: any = {
      comparingPriceSiteInfo: {
        check: this.check,
        info: this.comparingPriceSite
      }
    };
    this.$api.patchProducts({params, data}).then(({data}: any) => {
      if (data.failures && data.failures.length) {
        return alert(data.failures[0].message);
      }
      window.opener.postMessage({comparingPriceSite: true, data: JSON.parse(JSON.stringify(data))});
      this.close();
    });
  }

  private close() {
    window.close();
  }

  private popupResize() {
    const contentWidth = $('#container').width() + 50;
    const contentHeight = $('.content').height() + 120;
    window.resizeTo(contentWidth, contentHeight);
  }

  private created() {
    document.body.classList.add('popup', 'popup_large');
    this.$api.getProductsPriceComparisonSite({params: {productNo: this.productNo}}).then(({data: {check, info}}: any) => {
      if (check === 'ANY') {
        this.comparingPriceSite = [...info];
      } else if (check === 'ALL') {
        this.comparingPriceSite = [...channels];
      } else {
        this.comparingPrice = 'N';
      }
      const hasOriginInfo = this.comparingPriceSite.length > 0 || this.comparingPrice !== 'N'
      this.originComparingPriceSiteInfo = hasOriginInfo ? this.comparingPriceSite.slice() : [];
    });
    window.name = 'priceComparisonSite';
  }
}
